var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { BorderAll, CloudUpload, ExitToApp, ExpandLess, ExpandMore, FeaturedPlayList, Headset, Person, QueueMusic, Router, SettingsInputAntenna, } from "@material-ui/icons";
import { Collapse, List, ListItem, ListItemIcon, ListItemText, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { paths } from "frontend/src/pages/paths/index";
import { logout } from "frontend/src/features/session";
var path = paths.business.owner;
var isNestedLevel = function (props) { return "title" in props; };
var useStyles = makeStyles(function (theme) { return ({
    nested: {
        paddingLeft: function (_a) {
            var level = _a.level;
            return theme.spacing(level * 2);
        },
    },
}); });
var Nav = function (_a) {
    var name = _a.name, url = _a.url, icon = _a.icon, level = _a.level;
    var classes = useStyles({ level: level });
    var match = useRouteMatch(url);
    return (React.createElement(ListItem, { button: true, selected: Boolean(match), component: RouterLink, to: url, className: classes.nested },
        React.createElement(ListItemIcon, null, icon),
        React.createElement(ListItemText, { primary: name })));
};
var NestedNav = function (_a) {
    var title = _a.title, subItems = _a.subItems, icon = _a.icon;
    var match = useRouteMatch(subItems.map(function (_a) {
        var url = _a.url;
        return url;
    }));
    var isMatch = Boolean(match);
    var _b = __read(React.useState(isMatch), 2), open = _b[0], setOpen = _b[1];
    var _c = __read(React.useState(!open && isMatch), 2), selected = _c[0], setSelected = _c[1];
    var handleClick = function () {
        setOpen(!open);
    };
    React.useEffect(function () {
        if (!open && isMatch) {
            setSelected(true);
        }
    }, [open, isMatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem, { button: true, onClick: handleClick, selected: selected },
            React.createElement(ListItemIcon, null, icon),
            React.createElement(ListItemText, { primary: title }),
            open ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null)),
        React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
            React.createElement(List, { component: "div", disablePadding: true }, subItems.map(function (props) { return (React.createElement(Nav, __assign({ level: 2 }, props, { key: props.name }))); })))));
};
export var Navigation = function () {
    var onExit = function () { return logout(); };
    var nav = [
        {
            title: "Плейлисты",
            icon: React.createElement(QueueMusic, null),
            subItems: [
                {
                    name: "Мои",
                    url: path.playlists.index("private"),
                    icon: React.createElement(Person, null),
                },
                {
                    name: "imstream",
                    url: path.playlists.index("public"),
                    icon: React.createElement(Headset, null),
                },
            ],
        },
        {
            title: "Вещание",
            icon: React.createElement(SettingsInputAntenna, null),
            subItems: [
                {
                    name: "Сетки",
                    url: path.timetables.index(),
                    icon: React.createElement(BorderAll, null),
                },
                {
                    name: "Программы",
                    url: path.programs.index(),
                    icon: React.createElement(FeaturedPlayList, null),
                },
            ],
        },
        {
            name: "Загруженные файлы",
            icon: React.createElement(CloudUpload, null),
            url: path.files.index(),
        },
        {
            name: "Устройства",
            icon: React.createElement(Router, null),
            url: path.devices.index(),
        },
    ];
    return (React.createElement(List, null,
        nav.map(function (props) {
            return !isNestedLevel(props) ? (React.createElement(Nav, __assign({ key: props.name }, props, { level: 1 }))) : (React.createElement(NestedNav, __assign({ key: props.title }, props)));
        }),
        React.createElement(ListItem, { button: true, onClick: onExit },
            React.createElement(ListItemIcon, null,
                React.createElement(ExitToApp, null)),
            React.createElement(ListItemText, { primary: "Выход" }))));
};
